import useCalenderFilter from "../../../hooks/useCalenderFilter";
import {
  Box,
  Button,
  InputAdornment,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../styles/pages/superadmin/qcconfirmfilter.module.scss";
import dayjs from "dayjs";
import assest from "../../../json/assest";
import { DatePicker } from "@imarabinda/antd";
import { getDateApiFormat } from "../../../lib/functions/utils.lib";
const { RangePicker } = DatePicker;
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  setFrom,
  setTo,
} from "../../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { styled } from "@mui/material/styles";
import TableFilterIcon from "../../../ui/Icons/TableFilterIcon";
import TableCalenderIcon from "../../../ui/Icons/TableCalenderIcon";
import HeaderSearchIcon from "../../../ui/Icons/HeaderSearchIcon";
import BluesearchIcon from "../../../public/assets/icons/BluesearchIcon";
import SmresetIcon from "../../../public/assets/icons/SmresetIcon";
import CalenderDate from "../../../pages/Calender";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    marginTop: "5px",
    minWidth: "129px",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
    "& .MuiMenu-list": {
      padding: "11px 5px !important",
    },
    "& .MuiMenuItem-root": {
      fontWeight: "500",
      fontSize: "14px",
      color: "#7D7D7D",
      padding: "1px 3px",
      borderRadius: "5px",
      marginBottom: "3px",
      "&.Mui-selected": {
        background: "#F3F3F3",
      },
      "&:hover": {
        color: "#4b4b4b",
        background: "#F3F3F3",
      },
      "&:active": {
        background: "#F3F3F3",
        borderRadius: "5px",
      },
    },
  },
}));

export default function QcdenaiedApprovedWebsiteolyFilter({
  hideFilter,
  children,
  hideCalender,
  hideDateRangeFilter,
  rightItems,
  leftItems,
  FilterModalComponent,
  filterModalProps,
  filterActive,
  VIDEOList,
}) {
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    confirmCalenderTwo,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  const dispatch = useAppDispatch();

  const {
    handleTriggreFetch,
    handleInputChange,
    searchValue,
    setSearchValue,
    openFilterModal,
    setOpenFilterModal,
  } = filterModalProps;

  console.warn("setOpenFilterModal", openFilterModal, setOpenFilterModal);

  // const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);
  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }

      handleTriggreFetch();
    }
  }, [calenderValue]);

  return (
    <>
      {FilterModalComponent ? (
        <FilterModalComponent
          {...filterModalProps}
          open={openFilterModal}
          onClose={handleCloseFilterModal}
        />
      ) : null}
      <Stack
        direction={"row"}
        alignItems={"center"}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
        className={`${
          calenderFilter?.name !== "All time" ? styles.hideDaterow : ""
        } ${styles.tableTopHeader}`}
      >
        {!hideDateRangeFilter ? (
          <Box className={styles.videoDateTime}>
            {leftItems}

            {!filterActive ? (
              <Box className="commonSearchBar_modal">
                <p>
                  Showing videos for{" "}
                  {calenderFilter ? (
                    <>
                      <Box
                        className={`dayList ${
                          openedDateRangeFilter ? "date-black" : "date-blue"
                        }`}
                      >
                        <Button
                          aria-haspopup="true"
                          onClick={handleOpenDateRangeFilter}
                        >
                          {calenderFilter?.name}
                        </Button>
                        <StyledMenu
                          anchorEl={dateRangeFilterAnchor}
                          open={openedDateRangeFilter}
                          onClose={handleCloseDateRangeFilter}
                        >
                          {/* {DateFilterRangeList.slice(1).map((filter) => (
                            <MenuItem
                              onClick={changeCalenderFilter(filter)}
                              key={filter.name}
                              selected={filter === calenderFilter}
                            >
                              {filter.name}
                            </MenuItem>
                          ))} */}

                          {DateFilterRangeList.map((filter) => {
                            if (filter != calenderFilter) {
                              return (
                                <MenuItem
                                  onClick={changeCalenderFilter(filter)}
                                  key={filter.name}
                                  selected={filter === calenderFilter}
                                >
                                  {filter.name}
                                </MenuItem>
                              );
                            }
                          })}
                        </StyledMenu>
                      </Box>
                      <span className="dateList">
                        ({calenderFilterShowValue})
                      </span>
                    </>
                  ) : (
                    <>
                      the period from{" "}
                      {confirmedCalenderValue?.[0] ? (
                        <span className={styles.time_period}>
                          {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                        </span>
                      ) : null}{" "}
                      to{" "}
                      {calenderValue?.[1] ? (
                        <span className={styles.time_period}>
                          {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                        </span>
                      ) : null}
                    </>
                  )}
                </p>
                {/* {calenderFilter?.name !== "Today" ? ( */}
                {calenderFilter?.name !== "All time" ? (
                  <span className="reset_picker" onClick={resetCalender}>
                    {/* <span className="reset_picker" onClick={handleResetCalender}> */}
                    <svg
                      width="11"
                      height="11"
                      viewBox="0 0 11 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M4.22705 6.7832L6.77263 4.23762"
                        stroke="currentColor"
                        strokeWidth="0.8"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M6.77263 6.76238L4.22705 4.2168"
                        stroke="currentColor"
                        strokeWidth="0.8"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    reset
                  </span>
                ) : null}
              </Box>
            ) : (
              <>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={styles.morefileSelect}
                >
                  <p className={styles.moreFilter}>
                    Showing website-only videos for one or more selected
                    filters.
                  </p>
                  {/* <span className="noshow-result">3 results</span> */}
                  <span className="reset_picker">
                    <SmresetIcon /> reset
                  </span>
                </Stack>
              </>
            )}
          </Box>
        ) : null}
        {calenderFilter?.name === "All time" && !filterActive ? (
          <Box className="tableDataSearch">
            <TextField
              label=""
              id="outlined-size-normal"
              placeholder="Enter an email address, submitter name, VSID to search..."
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={searchValue ? styles.startAdmnt : undefined}
                  >
                    {searchValue ? <BluesearchIcon /> : <HeaderSearchIcon />}
                  </InputAdornment>
                ),
                endAdornment: searchValue?.length ? (
                  <InputAdornment position="end">
                    <Button onClick={() => setSearchValue("")}>Clear</Button>
                  </InputAdornment>
                ) : null,
              }}
              value={searchValue}
              onChange={handleInputChange}
              sx={
                searchValue
                  ? {
                      border: "1px solid #111AE9",
                      borderRadius: "6px",
                      [`& .MuiInputAdornment-positionStart`]: {
                        left: "15px !important",
                      },
                      [`& .MuiInputBase-input`]: {
                        boxShadow: "none !important",
                        height: "38px !important",
                        paddingLeft: "39px !important",
                        color: "#000",
                      },
                      [`& .MuiInputAdornment-positionEnd`]: {
                        [`& .MuiButtonBase-root`]: {
                          color: "#111AE9",
                          fontSize: "11px",
                          fontWeight: "500",
                          padding: "9px",
                          minWidth: "0",
                          [`&:hover`]: {
                            backgroundColor: "#fff",
                          },
                        },
                      },
                    }
                  : undefined
              }
            />
          </Box>
        ) : (
          " "
        )}
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.topHeaderRight}
        >
          {/* <Button className={styles.pendingBtn}>Pending Revision</Button> */}
          <List disablePadding>
            {!hideFilter ? (
              <ListItem>
                <Button
                  className={styles.btnstylesgray}
                  onClick={handleOpenFilterModal}
                >
                  <TableFilterIcon />
                </Button>
              </ListItem>
            ) : null}

            {/* {!hideCalender ? (
              <div
                id={calenderContainerId}
                style={{
                  opacity: 0,
                  visibility: "hidden",
                  position: "absolute",
                  right: "5%",
                }}
              >
                <RangePicker
                  value={calenderValue}
                  open={calenderOpen}
                  onCalendarChange={(val) => {
                    setCalenderValue(val);
                  }}
                  renderExtraFooter={() => (
                    <Stack direction="row" justifyContent={"flex-end"}>
                      <Button onClick={closeCalender}>Cancel</Button>
                      <Button onClick={confirmCalender} className="active">
         
                        Confirm
                      </Button>
                    </Stack>
                  )}
                />
              </div>
            ) : null} */}
            {/* 
            {!hideCalender ? (
              <ListItem>
                <Button
                  className={styles.btnstylesgray}
                  onClick={toggleCalender}
                >
                  <TableCalenderIcon />
                </Button>
              </ListItem>
            ) : null} */}

            <CalenderDate
              // setCalenderValue={setCalenderValue}
              confirmCalender={confirmCalenderTwo}
            />

            <ListItem>
              <Typography className={styles.allvideosCount}>
                <span>All videos:</span> {VIDEOList?.total}
              </Typography>
            </ListItem>
          </List>
          {rightItems}
        </Stack>
      </Stack>
      {children}
    </>
  );
}
